import {useMutation} from "@apollo/client";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_UPDATE_CHECKS_SENSITIVITY_RETRIES_AND_TIMEOUT_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetSRTForm} from "@/pages/checks/list/actions/bulkSetSensitivityRetriesAndTimeout/BulkSetSRTForm.tsx";

export interface EditCheckSensitivityRetriesAndTimeoutFormValues {
  msp_sensitivity: string;
  msp_num_retries: string;
  msp_threshold?: string;
}

export interface BulkSetSensitivityRetriesAndTimeoutModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetSRTModal = ({
  selectedItemsIds,
  show,
  setShow,
  onSuccess,
}: BulkSetSensitivityRetriesAndTimeoutModalProps) => {
  const [updateChecksSensitivityRetriesAndTimeout, {data, loading}] = useMutation<GraphQLResponse<null>>(
    GQL_UPDATE_CHECKS_SENSITIVITY_RETRIES_AND_TIMEOUT_STATE
  );

  const handleSubmit = async (data: EditCheckSensitivityRetriesAndTimeoutFormValues) => {
    const response = await updateChecksSensitivityRetriesAndTimeout({
      variables: {
        input: {
          ids: selectedItemsIds,
          msp_sensitivity: Number(data.msp_sensitivity),
          msp_num_retries: Number(data.msp_num_retries),
          msp_threshold:
            data.msp_threshold === "" || data.msp_threshold === undefined ? null : Number(data.msp_threshold),
        },
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkSetSRTForm";
  return (
    <FormModal
      size="lg"
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={"Set sensitivity, number of retries and timeout"}
    >
      <BulkSetSRTForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
